import Vue from 'vue'
import VueMoment from 'moment'

Vue.filter('formatDate', function (value) {
    if (value) {
        return VueMoment.unix(value).format('MMM-DD-YYYY, HH:mm:ss')
    }
});

Vue.filter('formatDateISO', function (value) {
    if (value) {
        return VueMoment(value).format('MMM-DD-YYYY, HH:mm:ss')
    }
});

export default VueMoment;